import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Map from '../RepFinderPage/components/Map';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";


import './RepFinderPage.scss';
import Spinner from '../../components/Spinner/spinner';

function RepFinderPage() {

  const {
    ready,
    value,
    suggestions: {status, data},
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      types: ['geocode'],  
      componentRestrictions: { country: "ca" }
    }
  });

  const [reps, setReps] = useState(null);
  const [location, setLocation] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [isNoReps, setIsNoReps] = useState(false);


  const [filteredSuggestions, setFilteredSuggestions] = useState([]);


  useEffect(() => {
    const locationSuggestionFiltering = async () => {
      const results = [];
      for (const suggestion of data) {
        try {
          
          const { structured_formatting: { main_text, secondary_text } } = suggestion;

          if (!(secondary_text && secondary_text.includes("Canada") && !secondary_text.includes(","))) {
            const geoCode = await getGeocode({ address: suggestion.description });
            
            const addressComponents = geoCode[0].address_components;
            const postalCode = addressComponents.find(component => component.types.includes('postal_code'))?.long_name;
            const city = addressComponents.find(component => component.types.includes('locality'))?.long_name;
            const province = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.short_name;

            if ((postalCode && province) || (city && province) || (postalCode && province && city)) {
              results.push(suggestion);
            }
          }
        } catch (error) {
          console.error("Geocoding error: ", error);
        }
      }
      setFilteredSuggestions(results);
    };
    if (data.length > 0) {
      locationSuggestionFiltering();
    }
  }, [data]);

  
  
  const getRepData = (postalCode, city, province) => {
    if (postalCode !== undefined && city !== undefined && province != undefined) {
        setIsLoaded(false);
        axios.get(`/aem_tools/api/getRepresentives`, {
          params: {postalCode: postalCode, city: city, province: province}
        })
        .then((res) => {
          if (JSON.stringify(res.data.data) !== "{}") {
            setReps(res.data.data.repData[0]);
          } else {
            setReps(null);
            setIsNoReps(true);
          }
          setIsLoaded(true);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  }

  const handleLocationInput = (e) => {
    setValue(e.target.value);
  }

  const isPostalCode = (input) => {
    return /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/.test(input);
  }; 

  const handleLocationSelection = async (description) => {
    setValue(description, false);
    clearSuggestions();
    
    try {
      const geoCode = await getGeocode({address: description});
      const {lat, lng} = await getLatLng(geoCode[0]);
      let postal_code = undefined;
      let city = undefined;
      let province = undefined;


      if (isPostalCode(geoCode[0].address_components[0].long_name)) {
        const addressComponents = geoCode[0].address_components;
        postal_code = addressComponents.find(component => component.types.includes('postal_code'))?.long_name;
        city = addressComponents.find(component => component.types.includes('locality'))?.long_name;
        province = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.short_name;

      } else {
        const reverseGeocodeResults = await getGeocode({ location: { lat, lng } }); 
        const addressComponents = reverseGeocodeResults[0].address_components;
        postal_code = addressComponents.find(component => component.types.includes('postal_code'))?.long_name;
        city = addressComponents.find(component => component.types.includes('locality'))?.long_name;
        province = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.short_name;
    
      }

      setLocation({lat, lng});
      getRepData(postal_code, city, province);

    } catch (error) {
      console.error("Error: ", error);
    }
  }

    const renderLocations = () => (
      filteredSuggestions.map((suggestion, index) => {
        const { structured_formatting: { main_text, secondary_text } } = suggestion;
        return (
            <li key={index} className='rf_suggestion-item' onClick={() => handleLocationSelection(suggestion.description)}>
            <strong>{main_text}</strong> <small>{secondary_text}</small>
            </li>
          );
        })
    );
  
    const selectFirstOption = () => {
      if (filteredSuggestions.length > 0) {
        handleLocationSelection(filteredSuggestions[0].description);
      }
    }

   const handleEnterLocation = (event) => {
    if (event.key === 'Enter') {
      selectFirstOption();
    }
   }


  return (
    <React.Fragment>
    <div className='repFinder-page-container'>
      <React.Fragment>
      {isLoaded === false && (
          <Spinner></Spinner>
      )}
      {isLoaded === true && (
        <div className='rf_search-form'>
          <div className='rf_results-area-container'>
            <div className='rf_search-box'>
              <input className="rf_search-string" id='rf_location_input' type="text" placeholder="Enter city or postal code" title="Enter city or zip" name="basf-rep-finder" autoComplete="off" value={value} onChange={handleLocationInput} disabled={!ready} onKeyDown={handleEnterLocation}/>
              <button className="rf_search-submit" title="Submit Search" onClick={selectFirstOption}>
                <span className="rf_search-submit-text"></span>
                <FontAwesomeIcon icon="fa-magnifying-glass"/>
              </button>
              {status === "OK" && (<ul className='rf_suggestions-area'>{renderLocations()}</ul>)}
              {isLoaded === true && (
                <div className='rf_results-area'>
                  <div className='rf_list-results'>
                    <div className="rf_list-results-area">
                      {reps !== null && (
                        <>
                          {reps.GR_Cell === '' && reps.GR_Email === '' ? (
                            null
                          ):(
                            <>
                              <dl key={0}>
                                <dt>{reps.GR_Title}</dt>
                                <dd id="list-result-637983" className="rf_rep-result-item">
                                  <div className="rf_rep-name">{reps.GR_RepName}</div>
                                  {reps.GR_Email != '' && (
                                    <div className="rf_rep-email">
                                      <a id="rep-finder" href={`mailto:${reps.GR_Email}`}><span className="icon icon-style email"><FontAwesomeIcon icon="fa-envelope"/></span> {reps.GR_Email}</a>
                                    </div>
                                  )}
                                  {reps.GR_Cell != '' && (
                                    <div className="rf_rep-phone">
                                      <a id="rep-finder"  href={`tel:${reps.GR_Cell}`}><span className="icon icon-style telephone"><FontAwesomeIcon icon="fa-phone-flip"/></span>{reps.GR_Cell}</a>
                                    </div>
                                  )}
                                </dd>
                              </dl>
                            </>
                          )}

                          {reps.RR_Cell === '' && reps.RR_Email === '' ? (
                            null
                          ) : (
                            <>
                              <dl key={1}>
                                <dt>{reps.RR_Title}</dt>
                                <dd id="list-result-637983" className="rf_rep-result-item">
                                  <div className="rf_rep-name">{reps.RR_RepName}</div>
                                  {reps.RR_Email != '' && (
                                    <div className="rf_rep-email">
                                      <a id="rep-finder" href={`mailto:${reps.RR_Email}`}><span className="icon icon-style email"><FontAwesomeIcon icon="fa-envelope"/></span> {reps.RR_Email}</a>
                                    </div>
                                  )}
                                  {reps.RR_Cell != '' && (
                                    <div className="rf_rep-phone">
                                      <a id="rep-finder" href={`tel:${reps.RR_Cell}`}><span className="icon icon-style telephone"><FontAwesomeIcon icon="fa-phone-flip"/></span>{reps.RR_Cell}</a>
                                    </div>
                                  )}
                                </dd>
                              </dl>
                            </>
                          )}
                        </>
                      )}
                      {reps === null && isNoReps === true &&  (
                        <p className='no_rep_found'>Sorry, it looks like there aren't any BASF Representatives in your specified location. Please call <b>AgSolutions</b><sup>®</sup> Customer Care at 1‑877‑371‑2273 for assistance.</p>
                      )}
                    </div>
                  </div> 
                </div>
              )}
            </div>
            {
              reps !== null ? (
                <div className='rf_map-results'>
                  <Map location={location} />
                </div>
              ) : (
                null
              )
            }
          </div>
        </div>
      )}
      </React.Fragment>
    </div>
  </React.Fragment>
  );
}

export default RepFinderPage;
